const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const names = (t) => { const m = t.match(/^(.*?)\s*\((.*?)\)\s*$/); return m ? [t, m[1], m[2]] : [t]; };

export const hasTool = (text, t) => names(t).some((n) => n.trim() && new RegExp(`(^|[^a-z0-9])${esc(n.trim().toLowerCase())}($|[^a-z0-9])`).test(text));

export const cvText = (cv = {}) => [cv.title, cv.summary, ...(cv.skills || []), ...(cv.certifications || []),
  ...(cv.experience || []).flatMap((e) => [e.role, ...(e.bullets || [])])].filter(Boolean).join(" ").toLowerCase();
